import Image from "next/image";
import React from "react";

export default function OffersText({ offer, slotScreen }) {
   return (
      <div
         key={offer.id}
         className={` ${
            slotScreen ? "flex-shrink-0" : "w-full"
         } relative p-[0.4px]  bg-gradient-to-r from-red-400 via-red-500 to-red-500 flex flex-row items-center border border_container`}
      >
         <div className="p-2 overflow-hidden bg-gradient-to-r w-full rounded-lg from-amber-100 via-orange-200 to-red-300 flex flex-row items-center ">
            <div className="flex flex-row space-x-2 items-center px-2 ">
               <Image
                  height={28}
                  width={28}
                  objectFit={"contains"}
                  src="https://playo-website.gumlet.io/venues-listing/offersPercent.png"
               />
               <span className="font-medium w-full text-on_background">{offer.offerName}</span>
            </div>
         </div>
      </div>
   );
}
